import React, { Component } from "react";
import { Icon, Card } from "antd";
import axios from "axios";
import moment from "moment";
import { Translate } from "react-translated";
import F from "../../../../Functions";
import StatBox from "../../../../components/stat-box";
import { API_DATE_FORMAT } from "../../../../utils/Constants";
const today = new Date();

class VirtualOnboardStats extends Component {
  state = {
    loading: true,
    period: this.props.period,
    start_date: this.props.start_date,
    end_date: this.props.end_date,
    vo_stats: {},
  };
  componentDidMount() {
    this.loadStats();
  }
  componentDidUpdate() {
    let { period, start_date, end_date } = this.props;

    if (
      period !== this.state.period ||
      start_date !== this.state.start_date ||
      end_date !== this.state.end_date
    ) {
      this.setState({ period, start_date, end_date }, () => {
        this.loadStats();
      });
    }
  }
  loadStats = () => {
    let { period, start_date, end_date } = this.props;

    // if (period === "all_bfiles") {
    //   const today = new Date();
    //   start_date = new Date("2010-01-01");
    //   end_date = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    // }

    let data = {};
    if (this.props.agency_id === null) {
      data.all_agency = true;
      data.agency_id = null;
    } else {
      data.all_agency = false;
      data.agency_id = this.props.agency_id;
    }
    // old condition
    // const route =
    //   this.props.user.type === "SUPER_ADMIN"
    //     ? "/api/ea_vo_stats"
    //     : "/api/am_vo_stats";

    // data.from = moment(start_date).format("YYYY-MM-DD");

    // data.to = moment(end_date).format("YYYY-MM-DD");

    data.from =
      period === "all_bfiles"
        ? moment(new Date("2010-01-01")).format("YYYY-MM-DD")
        : moment(new Date(start_date)).format(API_DATE_FORMAT) ;
    data.to =
      period === "all_bfiles"
        ? moment(new Date("2050-01-01")).format("YYYY-MM-DD")
        : moment(new Date(end_date)).format(API_DATE_FORMAT);

    // new condition
    const route =
      this.props.user.user_type &&
      this.props.user.user_type === "AGENCY_MANAGER"
        ? "/api/am_vo_stats"
        : "/api/ea_vo_stats";

    // new payload
    axios.post(route, data).then((res) => {
      this.setState({ vo_stats: res.data, loading: false });
    });
  };
  render() {
    const { period, start_date, end_date, user } = this.props;
    let { vo_stats, loading } = this.state;

    F.log("VOS loading =>", loading);

    let date_url = "";
    // if (period === "from_to") {
    //   date_url =
    //     "/all/" +
    //     encodeURIComponent(moment(start_date).format("MM/DD/YYYY")) +
    //     "/" +
    //     encodeURIComponent(moment(end_date).format("MM/DD/YYYY"));
    // }
    if (period === "all_bfiles") {
      date_url = "?all_bfiles";
    }

    return (
      <div>
        <Card
          title={
            <div>
              <Icon
                type="appstore"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={`Virtual Follow-Up Stats (Completed)`} />
            </div>
          }
          bordered={false}
          className="statsDetails"
        >
          <div className="statsGrid">
            <Card bordered={false} loading={loading}>
              <StatBox
                title="Customers Uploaded"
                val={vo_stats.count || 0}
                color={"yellow"}
                link={"/bfiles/von-calls-made" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
              <StatBox
                title="Scheduled Appointments For Follow Up"
                val={vo_stats.total_sent_to_efs || 0}
                color={"red"}
                link={"/bfiles/vo-sent-to-financial" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
              <StatBox
                title="Not Interested"
                val={vo_stats.not_interested || 0}
                color={"green"}
                link={"/bfiles/vo-not-interested" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
              <StatBox
                title="Not Reached"
                val={vo_stats.not_reached || 0}
                color={"purple"}
                link={"/bfiles/vo-not-reached" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
            </Card>
          </div>
        </Card>
      </div>
    );
  }
}

export default VirtualOnboardStats;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/ea/virtual-onboard-stats.js